export default "__VITE_ASSET__BADgmklz__"